import { ReactNode } from 'react';
import { TRUE } from '../../constants';
class FeatureFlag {
  private featureFlag: string | undefined;

  constructor(featureFlag: string | undefined) {
    this.featureFlag = featureFlag;
  }

  public validationByFilter({
    validationParam,
    source,
    resources,
  }: {
    validationParam: string | number;
    source: {}[];
    resources: {};
  }) {
    try {
      if (this.featureFlag === TRUE) {
        switch (source.length > 0) {
          case true:
            if (
              source.filter(
                (item) => item[validationParam] === resources[validationParam]
              ).length > 0
            ) {
              return false;
            }
            return source.push(resources);
          default:
            return source.push(resources);
        }
      }
      return false;
    } catch (error) {
      throw new Error('Error validating the data');
    }
  }

  public renderFlaggedComponent({ component }: { component: () => ReactNode }) {
    try {
      if (this.featureFlag === TRUE) return component();
      return false;
    } catch (error) {
      throw new Error('Error rendering the component');
    }
  }

  public basicValidation() {
    return this.featureFlag === TRUE;
  }
}

export { FeatureFlag };
